<template>
  <ApolloMutation
    :mutation="mutation"
    :update="update"
    :variables="{ id: myRun.id }"
    @done="onDone"
    @error="onError"
    tag
  >
    <template slot-scope="{ mutate, loading }">
      <v-dialog persistent v-model="dialog" width="300">
        <v-btn :loading="loading" color="success" slot="activator">
          Submit
          <span slot="loader">Loading...</span>
        </v-btn>
        <v-card>
          <v-card-title class="headline" primary-title>Read to submit?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialog=false" flat>Cancel</v-btn>
            <v-btn @click="submitRun(mutate)" color="success" flat>Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </ApolloMutation>
</template>

<script>
import { MY_RUNS, SUBMIT_RUN } from '@/graphql.gql';
import runMixin from '@/mixins/run';

export default {
  mixins: [runMixin],
  data() {
    return {
      mutation: SUBMIT_RUN,
      dialog: false,
    };
  },
  methods: {
    update(
      store,
      {
        data: { submitRun },
      }
    ) {
      const data = store.readQuery({ query: MY_RUNS });
      const index = data.myRuns.findIndex((obj) => obj.id === submitRun.id);
      data.myRuns[index].status = submitRun.status;
      store.writeQuery({ query: MY_RUNS, data });
      this.$router.push({ name: 'runs' });
    },
    onDone() {
      this.$router.push({ name: 'runs' });
    },
    onError(error) {
      // eslint-disable-next-line no-console
      console.log(error);
      this.$snackbar.show('We could not submit this run. Please, try again.');
    },
    async submitRun(mutate) {
      if (this.$v.myRun.config.$invalid) {
        this.$snackbar.show('Please, fill the form correctly.');
        return;
      }
      await mutate();
    },
  },
};
</script>
